import { push } from 'connected-react-router';
import { AnyAction } from 'redux';
import { reset } from 'redux-form';
import { put, spawn } from 'redux-saga/effects';
import swal from 'sweetalert';

export const NAVIGATE = 'NAVIGATE';
export const SHOW_ERROR = 'SHOW_ERROR';
export const SHOW_ERROR_YES = 'SHOW_ERROR_YES';
export const RESET_STATE = 'RESET_STATE';
export const RESTART_FLOW = 'RESTART_FLOW';

export const navigate = (payload: string) => ({
  payload,
  type: NAVIGATE,
});

export const showError = () => ({ type: SHOW_ERROR });

export const showErrorYes = () => ({ type: SHOW_ERROR_YES });

export const resetState = () => ({ type: RESET_STATE });

export const restartFlow = () => ({ type: RESTART_FLOW });

export function* doNavigate({ payload }: AnyAction) {
  yield put(push(payload));
}

export function* doError() {
  const alert = (args: any) => swal(args);

  yield spawn(alert, {
    button: 'Cerrar',
    icon: 'error',
    text: 'Por favor intente nuevamente.',
    title: 'Ha ocurrido un error',
  });
}

export function* doErrorYes() {
  const alert = (args: any) => swal(args);

  yield spawn(alert, {
    button: 'Cerrar',
    icon: 'warning',
    text:
      'Debido a que posees una Preexistencia deber realizar la cotización con nuestras ejecutivas al número 600 390 1000 o acércate a una de nuestras sucursales.',
    title: 'Estimado cliente',
  });
}

export function* doRestart() {
  yield put(reset('quote'));
  yield put(reset('proposal'));
  yield put(resetState());
  yield put(push('/'));
}
